import React from 'react'
import {selectMapperByKeys} from '../../mappers/util'
import {ScheduleAssignmentFilter} from '../../model/assigment.model'
import {getListSchedulingFilter} from '../../services/assigment.services'

export const useProgrammingServices = () => {
  const [loading, setLoading] = React.useState(false)
  const [programmingServices, setProgrammingServices] = React.useState<
    {value: string; label: string}[] | any[]
  >([])

  const getProgrammingServices = async (filters: ScheduleAssignmentFilter) => {
    try {
      setLoading(true)
      const response = await getListSchedulingFilter(filters)
      const programmingServices = response.data.data
      const mappedProgrammingServices = selectMapperByKeys(
        programmingServices,
        'Id',
        'Nomenclatura',
      )
      setProgrammingServices(mappedProgrammingServices)
    } catch (error) {
      console.error('Error fetching programming services:', error)
      setProgrammingServices([])
    } finally {
      setLoading(false)
    }
  }

  const clearProgrammingServices = () => {
    setProgrammingServices([])
  }

  return {
    loading,
    programmingServices,
    getProgrammingServices,
    clearProgrammingServices,
  }
}
